<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Costs</translate></template>
            <template v-slot:buttons>
                <!-- <OnboardingIntroLink :onboarding-intro="'onboarding_web_costs'" /> -->

                <GekkoButton 
                    :text="$gettext('New Cost')" 
                    icon="fa-solid fa-plus"
                    :to="Urls['costs_add_cost']()"
                    class="btn mr-2"
                />

                <b-dropdown right variant="outline-primary">
                    <template #button-content>
                        <font-awesome-icon icon="fa-solid fa-cloud-download" /><span v-translate>Download</span>
                    </template>
                    <b-dropdown-item @click="exportCosts('csv')" v-b-tooltip.hover.right :title="tooltipTextXls">
                        <font-awesome-icon icon="fa-regular fa-file" /><span v-translate>as excel file (.xls)</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="exportCosts('zip')" class="act" v-b-tooltip.hover.right :title="tooltipTextZip">
                        <font-awesome-icon icon="fa-regular fa-file-zipper" /><span v-translate>xls + images (.zip)</span>
                    </b-dropdown-item>
                </b-dropdown>
            </template>
        </TitleBar>
        <div class="content">
            <CostTable />
        </div>
    </div>
</template>
<script>
    import TitleBar from "@/components/TitleBar";
    import CostTable from "@/components/costs/CostTable";
    import GekkoButton from "@/components/GekkoButton";
    // import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"

    export default {

        name: "Costs",
        components: {
            TitleBar,
            CostTable,
            GekkoButton
            // OnboardingIntroLink
        },
        data() {
            return {
                tooltipTextZip: this.$gettext("Download current selection as xls, and include the proof images, as ZIP archive."),
                tooltipTextXls: this.$gettext("Download current selection as xls only.")
            }
        },
        methods: {
            exportCosts(exportFormat) {
                var url;
                if (exportFormat === 'csv') {
                    url = window.Urls['costs_export_costs']();
                } else {
                    url = window.Urls['costs_export_costs_zip']();
                }
                let filters = this.$store.getters['filterStore/getFilter'];
                filters.owner_company = window.company_id;
                delete filters.option;
                var queryString = this.encodeQueryData(filters);

                if (queryString) {
                    url += "?" + queryString;
                }
                if(exportFormat === "zip"){
                    var alert_text = this.$gettext("You will receive an email with your download URL as soon as your export is ready.");
                    this.$store.commit('setAlert', {title: this.$gettext("Cost Download"), text:alert_text, variant:"info",duration:4});
                }
                location.href = url;
            },
            encodeQueryData(data) {
                var ret = [];
                for (var d in data)
                    if (data[d]) {
                        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
                    }
                return ret.join("&");
            }
        }
    }
    ;
</script>
<style scoped>

</style>
